import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalHeader } from "../ModalHeader";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useEffect, useState } from "react";
import { Alert, Autocomplete, Divider, Grid, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import { ModalFooter } from "../ModalFooter";
import '../../../assets/styles/modals.scss';
import { PhasesService } from "@/service/services/Phases.service";
import { Loading } from "@/components/common/Loading";
import { AssistanceService } from "@/service/services/Assistance.service";
import { Props } from "./ModalGroupCompany.type";
import { requestTypeService } from "@/service/services/RequestType.service";
import { companiesService } from "@/service/services/Companies.service";
import { readLocalStorage } from "@/toolbox/helpers/local-storage-helper";
import { KEY_USER_DATA } from "@/toolbox/constants/local-storage";
import ___PHRASE from "@/service/translate/translateService";
import { apiResponseTranslate } from "@/toolbox/helpers/responseApi.helper";

export const ModalGroupCompany: React.FC<Props> = (props: any): JSX.Element => {

    const { open, closeModal, onList, groupCompany, clearState } = props;

    const [loading, setLoading] = useState<boolean>(false);
    const [companies, setCompanies] = useState<any>([]);
    const [newCompanySelected, setNewCompanySelected] = useState<any>(null)
    const userData = readLocalStorage(KEY_USER_DATA);
    const [data, setData] = useState({
        idcompany: null,
    });
    const user = readLocalStorage(KEY_USER_DATA)
    const [snackBarConfig, setSnackBarConfig] = useState<any>({
        open: false,
        severity: 'error',
        message: 'Error',
        autoHideDuration: 3000,
    });
   
    const validateForm = (values) => {
        let errors: any = {};
        // if (!newCompanySelected) errors.company = ___PHRASE("empresa")+" "+ ___PHRASE("requerido");
        return errors;
    }

    const onSubmit = async (values, { resetForm }) => {

        if(!newCompanySelected){
            return (
                setSnackBarConfig({...snackBarConfig, open:true, severity:'warning', message:___PHRASE("asegureseDeSeleccionarUnaEmpresa")})
            )
        }

        const formData = {
            idcompany: newCompanySelected.id,
            idadmin: userData.user.iduser,
        }

        setLoading(true);

        await companiesService.createRequestGroupCompany(formData).then((data) => {

            let apimessagge = apiResponseTranslate(data?.data?.message || '');

            if(data.data.status){
                setSnackBarConfig({...snackBarConfig, open:true, severity:'success', message:apimessagge})
            }else{
                setSnackBarConfig({...snackBarConfig, open:true, severity:'error', message:apimessagge})
            }
            setTimeout(()=>{
                onList && onList();
                closeModal && closeModal();
                setLoading(false);
        },2000)
        })

        setLoading(false);
    }

    const handleDecision = async(e,decision) =>{
        decision==1 && e.preventDefault();
        setLoading(true);

        await companiesService.editDecisionGroupCompany(groupCompany.id, decision).then((data) => {
            let apimessagge = apiResponseTranslate(data?.data?.message || '');
            if(data.data.status){
                setSnackBarConfig({...snackBarConfig, open:true, severity:'success', message:apimessagge})
            }else{
                setSnackBarConfig({...snackBarConfig, open:true, severity:'error', message:apimessagge})
            }
            setTimeout(()=>{
                onList && onList();
                closeModal && closeModal();
                setLoading(false);
        },2000)
            
        })
    }

    const getMyCompanies = async () => {
        const resp = await companiesService.companiesByUser(user.user.iduser);
        setCompanies(resp.data)
    }

    const onClose = () =>{
        closeModal();
        // clearState();
    }

    useEffect(() => {
        getMyCompanies();
    }, [])
    return (
        <>
            {loading && <Loading />}
            <Snackbar
            open={snackBarConfig.open} 
            autoHideDuration={snackBarConfig.autoHideDuration} 
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
            <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
                {snackBarConfig.message || ""}
            </Alert>
        </Snackbar>
            <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="sm">
                <ModalHeader
                    text={ groupCompany? ___PHRASE("grupoDeCompania") : ___PHRASE("agregar")+" "+___PHRASE("grupoDeCompania")}
                    className='positionElements'
                    onCancel={onClose}
                >
                </ModalHeader>
                <ModalBody>

                    {
                        groupCompany && <Typography variant="subtitle1" className="textColor"> 
                        {___PHRASE("deseaAceptarORechazarLaSolicitud")}
                      </Typography>
                    }
                    <Formik initialValues={data} enableReinitialize validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                        {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                            return (
                                <form onSubmit={ !groupCompany &&handleSubmit}>
                                    <Grid container >

                                        {!groupCompany && <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                            <Grid item xs={4}>
                                                <Typography variant="body1"><b>{___PHRASE("empresa")}:</b> </Typography>
                                            </Grid>
                                            <Grid item xs={8}>
                                                <Autocomplete
                                                    id="disable-portal"
                                                    disablePortal
                                                    value={newCompanySelected}
                                                    options={companies || []}
                                                    getOptionLabel={(option) => `${option.business_name} - ${option.registry_number}` || ""}
                                                    fullWidth
                                                    renderInput={(params) => <TextField {...params} variant="standard"
                                                    label={___PHRASE("escribeParaBuscar")} />}
                                                    onChange={(e, newValue) => {
                                                        setNewCompanySelected(newValue);
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                        }                                
                                    </Grid>
                                    {!groupCompany && <Divider />}
                                    <ModalFooter
                                        buttonType="submit"
                                        confirmText={ groupCompany ? ___PHRASE("aceptar") : ___PHRASE("solicitar")}
                                        cancelText={ groupCompany ? ___PHRASE("rechazar") : ___PHRASE("cancelar")}
                                        onCancel={groupCompany ? (e) => {handleDecision(e,3)} :handleSubmit}
                                        onConfirm={groupCompany ? (e) => {handleDecision(e,1)}:handleSubmit}
                                    />
                                </form>
                            )
                        }}
                    </Formik>
                </ModalBody>
            </Modal>
        </>
    );
}